import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import {
  Card,
  Row,
  Col,
  Button,
  Tabs,
  Badge,
  Descriptions,
  Statistic,
  Divider,
  Tag,
  Space,
  Spin,
  Alert,
  Modal,
  message,
  Empty,
  Table,
  Form,
  Input,
  Avatar,
  DatePicker,
  Popconfirm,
  Typography,
  Progress,
  Switch, 
  InputNumber, 
  Checkbox, 
  TimePicker,
  Select
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  BuildOutlined,
  UserOutlined,
  TeamOutlined,
  HomeOutlined,
  BankOutlined,
  CalendarOutlined,
  PhoneOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
  ArrowLeftOutlined,
  ApartmentOutlined,
  CrownOutlined,
  UsergroupAddOutlined,
  InfoCircleOutlined,
  HistoryOutlined,
  PlusOutlined,
  FileProtectOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import companyService from "../../../services/company/company.service";
import parasutService from "../../../services/parasut/parasut.service";
import { Company, CompanyDetailsForSuperAdmin, CompanyStatus, PaymentRecord, UpdateCompanyDto, UpdateSubscriptionDto, SubscriptionStatusEnum } from "../../../types/company.types";
import moment from "moment";
import "./styles.css";
import { handleApiError } from "../../../utils/errorHandler";
import { useTranslation } from "react-i18next";
import FooterSection from "../../shared/components/footerSection";
import { PermissionType, UserCreateDTO } from "../../../types/user.types";
import userService from "../../../services/user/user.service";
import { UpdateUserBySuperAdminDto } from "../../../types/user.types";
import branchService from "../../../services/branch/branch.service";
import { Store, UpdateBranchDto } from "../../../types/shop.types";
import departmentService from "../../../services/department/department.service";
import { DepartmentDto, UpdateDepartmentDto } from "../../../types/department.types";
import { User } from "../../../types/user.types";
import { useWatch } from "antd/lib/form/Form";
import { RolesEnum } from "../../../types/route.types";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
const { TabPane } = Tabs;
const { confirm } = Modal;
const { Text } = Typography;
const { Option } = Select;

const CompanyDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [company, setCompany] = useState<Company | null>(null);
  const [subscriptionInfo, setSubscriptionInfo] = useState<CompanyDetailsForSuperAdmin | null>(null);
  const [paymentHistory, setPaymentHistory] = useState<PaymentRecord[]>([]);
  const [isHistoryModalVisible, setIsHistoryModalVisible] = useState<boolean>(false);
  const [historyLoading, setHistoryLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [subLoading, setSubLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isAddAdminModalVisible, setIsAddAdminModalVisible] = useState<boolean>(false);
  const [addingAdmin, setAddingAdmin] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const { t } = useTranslation();
  const [selectedAdmin, setSelectedAdmin] = useState<any>(null);
  const [adminDetailModalVisible, setAdminDetailModalVisible] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [userDetailModalVisible, setUserDetailModalVisible] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('info');
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [updatingCompany, setUpdatingCompany] = useState(false);
  const [isUserEditModalVisible, setIsUserEditModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState<any | null>(null);
  const [adminSearchTerm, setAdminSearchTerm] = useState('');
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [editingBranch, setEditingBranch] = useState<Store | null>(null);
  const [isBranchEditModalVisible, setIsBranchEditModalVisible] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState<DepartmentDto | null>(null);
  const [isDepartmentEditModalVisible, setIsDepartmentEditModalVisible] = useState(false);
  const [isSubscriptionModalVisible, setIsSubscriptionModalVisible] = useState(false);
  const [subscriptionEditForm] = Form.useForm();
  const [userEditForm] = Form.useForm();
  const [formKey, setFormKey] = useState(0);
  const { user } = useSelector((state: RootState) => state.auth);
  const statusValue = useWatch('subscriptionStatus', subscriptionEditForm);
  
  // Parasut işlemleri için state'ler
  const [parasutLoading, setParasutLoading] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    fetchCompany();
  }, [id]);

  useEffect(() => {
    if (!id) return;
    const fetchSubscriptionDetails = async () => {
      try {
        setSubLoading(true);
        const data = await companyService.getCompanyDetailsForSuperAdmin(Number(id));
        setSubscriptionInfo(data);
      } catch (err) {
      } finally {
        setSubLoading(false);
      }
    };
    fetchSubscriptionDetails();
  }, [id]);

  useEffect(() => {
    if (isSubscriptionModalVisible && subscriptionInfo) {
      subscriptionEditForm.resetFields();
      subscriptionEditForm.setFieldsValue({
        userLimit: subscriptionInfo.userLimit,
        subscriptionStatus: subscriptionInfo.subscriptionStatus,
        activeSubscriptionExpiresAt: subscriptionInfo.activeSubscriptionExpiresAt
          ? moment(subscriptionInfo.activeSubscriptionExpiresAt)
          : null,
        gracePeriodEndsAt: subscriptionInfo.gracePeriodEndsAt
          ? moment(subscriptionInfo.gracePeriodEndsAt)
          : null,
      });
    }
  }, [isSubscriptionModalVisible, subscriptionInfo, subscriptionEditForm]);

  const showPaymentHistory = async () => {
    if (!id) return;
    try {
      setHistoryLoading(true);
      setIsHistoryModalVisible(true);
      const historyData = await companyService.getCompanyPaymentHistory(Number(id));
      setPaymentHistory(historyData);
    } catch (err) {
      message.error("Ödeme geçmişi alınamadı.");
    } finally {
      setHistoryLoading(false);
    }
  };

  const fetchCompany = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await companyService.getCompanyById(Number(id));
      
      // createdBy bilgisini işle
      if (data && data.createdBy) {
        const createdByName = data.createdBy.firstName && data.createdBy.lastName
          ? `${data.createdBy.firstName} ${data.createdBy.lastName}`
          : data.createdBy.name || 'Süper Admin';
        
        setCompany({
          ...data,
          createdBySuperAdmin: true,
          createdBySuperAdminName: createdByName
        });
      } else {
        setCompany(data);
      }
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setLoading(false);
    }
  };

  const showEditModal = () => {
    if (!company) return;
  
    const settings = company.settings || {};
    const formValues = {
      ...company,
      settings: {
        ...settings,
      }
    };
    editForm.setFieldsValue(formValues);
    setIsEditModalVisible(true);
  };

  const handleUpdateCompany = async (values: any) => {
    if (!id) return;
  
    setUpdatingCompany(true);
    try {
      const { settings, ...rest } = values;
  
      // Create the settings payload. Start with original settings to prevent data loss,
      // then override with new values from the form.
      const settingsPayload = {
        ...(company?.settings || {}),
        ...settings,
      };

      // Automatically set useFixedShift based on shiftMode
      if ('shiftMode' in settingsPayload) {
        settingsPayload.useFixedShift = settingsPayload.shiftMode === 'fixed' || settingsPayload.shiftMode === 'both';
      }

      // Ensure lateTolerationMinutes is handled correctly
      if (!settingsPayload.lateTolerance) {
        settingsPayload.lateTolerationMinutes = 0; // Reset minutes if tolerance is off
      }
      
      const payload: Partial<UpdateCompanyDto> = {
        ...rest,
        settings: settingsPayload
      };
  
      await companyService.updateCompany(Number(id), payload);
      message.success("Şirket bilgileri başarıyla güncellendi.");
      setIsEditModalVisible(false);
      fetchCompany();
    } catch (error) {
      handleApiError(error, t);
    } finally {
      setUpdatingCompany(false);
    }
  };

  const handleDelete = () => {
    confirm({
      title: "Bu şirketi silmek istediğinize emin misiniz?",
      icon: <ExclamationCircleOutlined />,
      content: "Bu işlem geri alınamaz!",
      okText: "Evet",
      okType: "danger",
      cancelText: "Hayır",
      onOk: async () => {
        try {
          await companyService.deleteCompany(Number(id));
          message.success("Şirket başarıyla silindi.");
          navigate(all_routes.superAdminCompanies);
        } catch (error: any) {
          handleApiError(error, t);
        }
      },
    });
  };

  const deleteUser = async (user: any) => {
    try {

      await userService.hardDeleteUser(user.id);
      message.success("Kullanıcı başarıyla silindi.");
      fetchCompany();
    } catch (error: any) {
      handleApiError(error, t);
    }
  };

  const getStatusBadge = (status?: CompanyStatus) => {
    if (!status) return <Badge status="default" text="Bilinmiyor" />;

    switch (status) {
      case CompanyStatus.ACTIVE:
        return <Badge status="success" text="Aktif" />;
      case CompanyStatus.INACTIVE:
        return <Badge status="default" text="Pasif" />;
      case CompanyStatus.DELETED:
        return <Badge status="error" text="Silindi" />;
      default:
        return <Badge status="processing" text="Bilinmiyor" />;
    }
  };

  const getSubscriptionStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
        case 'active': return 'success';
        case 'inactive': return 'default';
        case 'expired': return 'error';
        case 'trial': return 'processing';
        case 'in_grace_period': return 'warning';
        default: return 'default';
    }
  };

  const translateSubscriptionStatus = (status: string) => {
      switch (status?.toLowerCase()) {
          case 'active': return 'Aktif';
          case 'inactive': return 'Pasif';
          case 'expired': return 'Süresi Dolmuş';
          case 'trial': return 'Deneme';
          case 'in_grace_period': return 'Tolerans Süresinde';
          default: return status;
      }
  };

  const translatePaymentStatus = (status: string) => {
    switch (status) {
      case 'paid':
        return 'Ödendi';
      case 'unpaid':
        return 'Ödenmedi';
      case 'failed':
        return 'Başarısız';
      case 'pending':
        return 'Beklemede';
      default:
        return status;
    }
  };

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case 'paid':
        return 'success';
      case 'unpaid':
        return 'warning';
      case 'failed':
        return 'error';
      case 'pending':
        return 'processing';
      default:
        return 'default';
    }
  };

  const translateDayName = (day: string) => {
    const dayMap: { [key: string]: string } = {
      'Monday': 'Pazartesi',
      'Tuesday': 'Salı',
      'Wednesday': 'Çarşamba',
      'Thursday': 'Perşembe',
      'Friday': 'Cuma',
      'Saturday': 'Cumartesi',
      'Sunday': 'Pazar',
    };
    return dayMap[day] || day;
  };

  // Admin kullanıcılarını filtrele
  const adminUsers = company?.users?.filter(user => user.role === RolesEnum.ADMIN) || [];
  const hasAdminUsers = adminUsers.length > 0;

  // Yeni admin kullanıcısı ekleme
  const handleAddAdmin = async (values: any) => {
    try {
      setAddingAdmin(true);

      const createData: UserCreateDTO = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        password: values.password,
        phone: values.phone || undefined,
        nationalId: values.nationalId.trim(),
        role: RolesEnum.ADMIN,
        companyId: Number(id), // Süper admin için companyId zorunlu
        department: null,
        branch: null,
      };

      await userService.createUser(createData);
      message.success("Admin kullanıcısı başarıyla eklendi.");
      setIsAddAdminModalVisible(false);
      form.resetFields();
      fetchCompany(); // Şirket verilerini yeniden yükle
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setAddingAdmin(false);
    }
  };

  // Kullanıcı iznini Türkçe olarak gösterme
  const getPermissionName = (permission: string) => {
    const permissionMap: { [key: string]: string } = {
      'control_panel_admin': 'Kontrol Paneli Erişimi',
      'view_users': 'Kullanıcıları Görüntüleme',
      'edit_users': 'Kullanıcıları Düzenleme',
      'view_departments': 'Departmanları Görüntüleme',
      'edit_departments': 'Departmanları Düzenleme',
      'view_branches': 'Şubeleri Görüntüleme',
      'edit_branches': 'Şubeleri Düzenleme',
      'export': 'Veri Dışa Aktarma',
      'edit_leave': 'İzinleri Düzenleme',
      'view_leave': 'İzinleri Görüntüleme',
      'manage_leave_hierarchy': 'İzin Onay Hiyerarşisi',
      'view_reports': 'Raporları Görüntüleme',
      'manage_shifts': 'Vardiyaları Yönetme',
      'view_salaries': 'Maaşları Görüntüleme',
      'company_settings': 'Şirket Ayarları',
      'create_notifications': 'Bildirim Oluşturma',
      'file_view': 'Dosya Görüntüleme',
      'view_tickets_admin': 'Destek Taleplerini Görüntüleme',
      'edit_tickets': 'Destek Taleplerini Düzenleme',
      'check_in_out': 'Giriş Çıkış Yapma',
      'break': 'Mola alma',
      'control_panel_user': 'Calisan Paneli Erişimi',
      'file_upload': 'Dosya Yükleme',
      'view_tickets_user': 'Talepleri Görüntüleme',
      'leave_request': 'İzin Talep Etme',
      'manage_company': 'Şirket Yönetimi',
      'view_company_timesheet': 'Şirket Puantaj Raporunu Görüntüleme',
      'view_company_payment': 'Şirket Ödeme Raporunu Görüntüleme',
      'view_meals': 'Yemek Raporunu Görüntüleme',
      'view_vehicles': 'Araçları Görüntüleme',
      'manage_vehicles': 'Araçları Yönetme',
      'view_field_activities': 'Saha Aktivitelerini Görüntüleme',
      'manage_field_activities': 'Saha Aktivitelerini Yönetme',
    };

    return permissionMap[permission] || permission;
  };

  // Admin detaylarını göster
  const showAdminDetail = (admin: any) => {
    setSelectedAdmin(admin);
    setAdminDetailModalVisible(true);
  };

  // Kullanıcı detaylarını göster
  const showUserDetail = (user: any) => {
    setSelectedUser(user);
    setUserDetailModalVisible(true);
  };

  // Admin kullanıcı izinlerini göster
  const renderPermissions = (permissions: string[]) => {
    if (!permissions || permissions.length === 0) {
      return <Empty description="İzin bulunamadı" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }

    return (
      <div className="permission-tags">
        {permissions.map(permission => (
          <Tag color="blue" key={permission} className="mb-1 me-1">
            {getPermissionName(permission)}
          </Tag>
        ))}
      </div>
    );
  };

  const adminColumns = [
    {
      title: '',
      dataIndex: 'profilePicture',
      key: 'profilePicture',
      width: 60,
      render: (profilePic: string, record: any) => (
        <Avatar
          src={profilePic ? `/uploads/${profilePic}` : null}
          icon={!profilePic ? <UserOutlined /> : null}
        />
      ),
    },
    {
      title: 'Ad Soyad',
      key: 'fullName',
      render: (text: string, record: any) => (
        <div>
          <div className="fw-bold">{record.firstName} {record.lastName}</div>
          <div className="text-muted small">{record.title || '-'}</div>
        </div>
      ),
    },
    {
      title: 'İletişim Bilgileri',
      key: 'contact',
      render: (text: string, record: any) => (
        <div>
          <div><MailOutlined className="me-1" /> {record.email}</div>
          <div><PhoneOutlined className="me-1" /> {record.phone || '-'}</div>
        </div>
      ),
    },
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        let badgeStatus: any = 'default';
        let text = 'Bilinmiyor';

        if (status === 'active') {
          badgeStatus = 'success';
          text = 'Aktif';
        } else if (status === 'inactive') {
          badgeStatus = 'default';
          text = 'Pasif';
        } else if (status === 'suspended') {
          badgeStatus = 'error';
          text = 'Askıya Alınmış';
        }

        return <Badge status={badgeStatus} text={text} />;
      },
    },
    {
      title: 'İşe Başlama',
      dataIndex: 'hireDate',
      key: 'hireDate',
      render: (date: string) => date ? moment(date).format('DD.MM.YYYY') : '-',
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (text: string, record: any) => (
        <Space size="small">
          <Button type="default" size="small" icon={<BuildOutlined />} onClick={() => showAdminDetail(record)} />
        </Space>
      ),
    }
  ];

  const usersColumns = [
    {
      title: '',
      dataIndex: 'profilePicture',
      key: 'profilePicture',
      width: 60,
      render: (profilePic: string, record: any) => (
        <Avatar
          src={profilePic ? `/uploads/${profilePic}` : null}
          icon={!profilePic ? <UserOutlined /> : null}
        />
      ),
    },
    {
      title: 'Ad Soyad',
      key: 'fullName',
      render: (text: string, record: any) => (
        <div>
          <div className="fw-bold">{record.firstName} {record.lastName}</div>
          <div className="text-muted small">{record.title || '-'}</div>
        </div>
      ),
    },
    {
      title: 'İletişim Bilgileri',
      key: 'contact',
      render: (text: string, record: any) => (
        <div>
          <div><MailOutlined className="me-1" /> {record.email}</div>
          <div><PhoneOutlined className="me-1" /> {record.phone || '-'}</div>
        </div>
      ),
    },
    {
      title: 'Rol',
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => {
        const roleMap: { [key: string]: { color: string, text: string } } = {
          'admin': { color: 'red', text: 'Admin' },
          'superadmin': { color: 'blue', text: 'Super Admin' },
          'manager': { color: 'orange', text: 'Yönetici' },
          // 'supervisor': { color: 'blue', text: 'Sorumlu' },
          'user': { color: 'green', text: 'Çalışan' }
        };

        const roleInfo = roleMap[role?.toLowerCase()] || { color: 'default', text: role || 'Bilinmiyor' };

        return <Tag color={roleInfo.color}>{roleInfo.text}</Tag>;
      }
    },
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        let badgeStatus: any = 'default';
        let text = 'Bilinmiyor';

        if (status === 'active') {
          badgeStatus = 'success';
          text = 'Aktif';
        } else if (status === 'inactive') {
          badgeStatus = 'default';
          text = 'Pasif';
        } else if (status === 'suspended') {
          badgeStatus = 'error';
          text = 'Askıya Alınmış';
        }

        return <Badge status={badgeStatus} text={text} />;
      },
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (text: string, record: any) => (
        <Space size="small">
          <Button type="default" size="small" icon={<BuildOutlined />} onClick={() => showUserDetail(record)} />
        </Space>
      ),
    }
  ];

  const branchesColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Şube Adı',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Adres',
      dataIndex: 'address',
      key: 'address',
      render: (address: string) => address || <Text type="secondary">---</Text>,
    },
    {
      title: 'Telefon',
      dataIndex: 'phone',
      key: 'phone',
      render: (phone: string) => phone || <Text type="secondary">---</Text>,
    },
    {
      title: 'IP Adresleri',
      dataIndex: 'ipAddresses',
      key: 'ipAddresses',
      render: (ips: string[]) => (
        ips && ips.length > 0 
          ? ips.map(ip => <Tag color="purple" key={ip}>{ip}</Tag>) 
          : <Text type="secondary">Tanımlı Değil</Text>
      ),
    },
    {
      title: 'Durum',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'success' : 'default'}>
          {status === 'active' ? 'Aktif' : 'Pasif'}
        </Tag>
      )
    },
    // Düzenleme işlemleri kaldırıldı
  ];

  const departmentsColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'Departman Adı',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Çalışma Saatleri',
      key: 'workingHours',
      render: (record: any) => (
        record.fixedShiftStartTime && record.fixedShiftEndTime
          ? `${record.fixedShiftStartTime} - ${record.fixedShiftEndTime}`
          : <Text type="secondary">Varsayılan</Text>
      ),
    },
    {
      title: 'Çalışma Günleri',
      dataIndex: 'fixedShiftDays',
      key: 'fixedShiftDays',
      render: (days: string[]) => (
        days && days.length > 0
          ? days.map(day => <Tag key={day} color="blue">{translateDayName(day)}</Tag>)
          : <Text type="secondary">Varsayılan</Text>
      ),
    },
    // Düzenleme işlemleri kaldırıldı
  ];

  const navigationItems = [
    { key: 'info', label: 'Genel Bilgiler', icon: <UserOutlined />, count: null },
    { key: 'admins', label: 'Admin Kullanıcılar', icon: <TeamOutlined />, count: adminUsers.length },
    { key: 'users', label: 'Çalışanlar', icon: <TeamOutlined />, count: company?.users?.length || 0 },
    { key: 'branches', label: 'Şubeler', icon: <HomeOutlined />, count: company?.branches?.length || 0 },
    { key: 'departments', label: 'Departmanlar', icon: <ApartmentOutlined />, count: company?.departments?.length || 0 }
  ];

  const filteredAdminUsers = adminUsers.filter(user =>
    `${user.firstName} ${user.lastName}`.toLowerCase().includes(adminSearchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(adminSearchTerm.toLowerCase())
  );

  const filteredUsers = (company?.users || []).filter(user =>
    `${user.firstName} ${user.lastName}`.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(userSearchTerm.toLowerCase())
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'info':
        return (
          <div className="tab-content-wrapper">
            <div className="section-header">
              <h4 className="section-title">Şirket Bilgileri</h4>
              <p className="section-description">Şirketin genel bilgileri ve ayarları</p>
            </div>

            <div className="info-grid">
              <div className="info-card">
                <div className="info-card-header">
                  <h5>Temel Bilgiler</h5>
                </div>
                <div className="info-card-body">
                  <div className="info-item">
                    <span className="info-label">Şirket Adı:</span>
                    <span className="info-value">{company?.name}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">E-posta:</span>
                    <span className="info-value">{company?.email || "-"}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Telefon:</span>
                    <span className="info-value">{company?.phone || "-"}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Durum:</span>
                    <span className="info-value">{getStatusBadge(company?.status)}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Adres:</span>
                    <span className="info-value">{company?.address || "-"}</span>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <div className="info-card-header">
                  <h5>Vergi Bilgileri</h5>
                </div>
                <div className="info-card-body">
                  <div className="info-item">
                    <span className="info-label">Vergi No:</span>
                    <span className="info-value">{company?.taxNumber}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Vergi Dairesi:</span>
                    <span className="info-value">{company?.taxOffice}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Kayıt Tarihi:</span>
                    <span className="info-value">{moment(company?.createdAt).format("DD.MM.YYYY HH:mm")}</span>
                  </div>
                  {company?.createdBySuperAdmin && (
                    <div className="info-item">
                      <span className="info-label">
                        <CrownOutlined className="me-1" style={{ color: '#faad14' }} />
                        Oluşturan Süper Admin:
                      </span>
                      <span className="info-value">
                        <Tag color="gold" icon={<CrownOutlined />}>
                          {company?.createdBySuperAdminName || 'Süper Admin'}
                        </Tag>
                      </span>
                    </div>
                  )}
                  <div className="info-item">
                    <span className="info-label">Son Güncelleme:</span>
                    <span className="info-value">{moment(company?.updatedAt).format("DD.MM.YYYY HH:mm")}</span>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <div className="info-card-header">
                  <h5>Şirket Ayarları</h5>
                </div>
                <div className="info-card-body">
                  <div className="info-item">
                    <span className="info-label">Varsayılan Mola Süresi:</span>
                    <span className="info-value">{company?.settings?.defaultBreakDuration} dakika</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Geç Kalma Toleransı:</span>
                    <span className="info-value">
                      {company?.settings?.lateTolerance ? (
                        <Badge status="success" text={`Evet (${company.settings.lateTolerationMinutes} dakika)`} />
                      ) : (
                        <Badge status="default" text="Hayır" />
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">İzin Talepleri için E-posta:</span>
                    <span className="info-value">
                      {company?.settings?.sendMailLeave ? (
                        <Badge status="success" text="Evet" />
                      ) : (
                        <Badge status="default" text="Hayır" />
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">IP Kontrolü:</span>
                    <span className="info-value">
                      {company?.settings?.ipControl ? (
                        <Badge status="success" text="Evet" />
                      ) : (
                        <Badge status="default" text="Hayır" />
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Yıllık İzin Limiti:</span>
                    <span className="info-value">{company?.settings?.annualLeaveLimit || "-"} gün</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Maks. Günlük Çalışma:</span>
                    <span className="info-value">{company?.settings?.maxDailyWorkHours || "-"} saat</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Maks. Mola Süresi:</span>
                    <span className="info-value">{company?.settings?.maxBreakDuration || "-"} dakika</span>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <div className="info-card-header">
                  <h5>Vardiya Ayarları</h5>
                </div>
                <div className="info-card-body">
                  <div className="info-item">
                    <span className="info-label">Vardiya Modu:</span>
                    <span className="info-value">
                      {company?.settings?.shiftMode === "assignment" && "Atama Bazlı"}
                      {company?.settings?.shiftMode === "fixed" && "Sabit"}
                      {company?.settings?.shiftMode === "both" && "Her İkisi"}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Sabit Vardiya Kullanımı:</span>
                    <span className="info-value">
                      {company?.settings?.useFixedShift ? (
                        <Badge status="success" text="Evet" />
                      ) : (
                        <Badge status="default" text="Hayır" />
                      )}
                    </span>
                  </div>
                  {company?.settings?.useFixedShift && (
                    <>
                      <div className="info-item">
                        <span className="info-label">Sabit Vardiya Günleri:</span>
                        <div className="info-value">
                          {company.settings?.fixedShiftDays?.map((day) => (
                            <Tag key={day} color="blue" className="me-1 mb-1">
                              {day === "Monday" && "Pazartesi"}
                              {day === "Tuesday" && "Salı"}
                              {day === "Wednesday" && "Çarşamba"}
                              {day === "Thursday" && "Perşembe"}
                              {day === "Friday" && "Cuma"}
                              {day === "Saturday" && "Cumartesi"}
                              {day === "Sunday" && "Pazar"}
                            </Tag>
                          ))}
                        </div>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Sabit Vardiya Başlangıç Saati:</span>
                        <span className="info-value">{company.settings?.fixedShiftStartTime || "-"}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Sabit Vardiya Bitiş Saati:</span>
                        <span className="info-value">{company.settings?.fixedShiftEndTime || "-"}</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <h5>Bildirim Ayarları</h5>
                </div>
                <div className="info-card-body">
                  <div className="info-item">
                    <span className="info-label">İzin E-postası:</span>
                    <span className="info-value">{company?.settings?.sendMailLeave ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Talep E-postası:</span>
                    <span className="info-value">{company?.settings?.sendMailTicket ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Mazeret E-postası:</span>
                    <span className="info-value">{company?.settings?.sendMailExcuse ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">İzin Bildirimi:</span>
                    <span className="info-value">{company?.settings?.sendNotifLeave ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Talep Bildirimi:</span>
                    <span className="info-value">{company?.settings?.sendNotifTicket ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Mazeret Bildirimi:</span>
                    <span className="info-value">{company?.settings?.sendNotifExcuse ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                   <div className="info-item">
                    <span className="info-label">Mola Bildirimi:</span>
                    <span className="info-value">{company?.settings?.sendNotifBreak ? <Badge status="success" text="Evet" /> : <Badge status="default" text="Hayır" />}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'admins':
        return (
          <div className="tab-content-wrapper">
            <div className="section-header">
              <div>
                <h4 className="section-title">Admin Kullanıcılar</h4>
                <p className="section-description">Bu şirkete atanmış admin kullanıcıları</p>
              </div>
              <div className="d-flex align-items-center gap-2">
                <Input.Search 
                  placeholder="Admin ara..." 
                  onChange={e => setAdminSearchTerm(e.target.value)}
                  style={{ width: 250 }}
                />
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setIsAddAdminModalVisible(true)}
                >
                  Admin Ekle
                </Button>
              </div>
            </div>

            {filteredAdminUsers.length > 0 ? (
              <div className="table-wrapper">
                <Table
                  dataSource={filteredAdminUsers}
                  columns={adminColumns}
                  rowKey="id"
                  pagination={false}
                  className="modern-table"
                />
              </div>
            ) : (
              <div className="empty-state">
                <Empty description="Bu şirkete atanmış admin kullanıcısı bulunmuyor" />
              </div>
            )}
          </div>
        );

      case 'users':
        return (
          <div className="tab-content-wrapper">
            <div className="section-header">
              <div>
                <h4 className="section-title">Çalışanlar</h4>
                <p className="section-description">Şirkete kayıtlı tüm çalışanlar</p>
              </div>
               <Input.Search 
                  placeholder="Çalışan ara..." 
                  onChange={e => setUserSearchTerm(e.target.value)}
                  style={{ width: 250 }}
                />
            </div>

            {filteredUsers.length > 0 ? (
              <div className="table-wrapper">
                <Table
                  dataSource={filteredUsers}
                  columns={usersColumns}
                  rowKey="id"
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`
                  }}
                  className="modern-table"
                />
              </div>
            ) : (
              <div className="empty-state">
                <Empty description="Bu şirkete kayıtlı çalışan bulunmuyor" />
              </div>
            )}
          </div>
        );

      case 'branches':
        return (
          <div className="tab-content-wrapper">
            <div className="section-header">
              <div>
                <h4 className="section-title">Şubeler</h4>
                <p className="section-description">Şirkete kayıtlı şubeler</p>
              </div>
            </div>

            {company?.branches && company.branches.length > 0 ? (
              <div className="table-wrapper">
                <Table
                  dataSource={company.branches}
                  columns={branchesColumns}
                  rowKey="id"
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`
                  }}
                  className="modern-table"
                />
              </div>
            ) : (
              <div className="empty-state">
                <Empty description="Bu şirkete kayıtlı şube bulunmuyor" />
              </div>
            )}
          </div>
        );

      case 'departments':
        return (
          <div className="tab-content-wrapper">
            <div className="section-header">
              <div>
                <h4 className="section-title">Departmanlar</h4>
                <p className="section-description">Şirkete kayıtlı departmanlar</p>
              </div>
            </div>

            {company?.departments && company.departments.length > 0 ? (
              <div className="table-wrapper">
                <Table
                  dataSource={company.departments}
                  columns={departmentsColumns}
                  rowKey="id"
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`
                  }}
                  className="modern-table"
                />
              </div>
            ) : (
              <div className="empty-state">
                <Empty description="Bu şirkete kayıtlı departman bulunmuyor" />
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div className="page-wrapper vh-100 d-flex flex-column justify-content-center align-items-center">
        <Spin size="large" />
        <p className="mt-3">Şirket bilgileri yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-wrapper vh-100 d-flex flex-column justify-content-center align-items-center">
        <Alert
          message="Hata"
          description={error}
          type="error"
          showIcon
          action={
            <Button type="primary" onClick={() => navigate(all_routes.superAdminCompanies)}>
              Şirketlere Dön
            </Button>
          }
        />
      </div>
    );
  }

  if (!company) {
    return (
      <div className="page-wrapper vh-100 d-flex flex-column justify-content-center align-items-center">
        <Empty
          description="Şirket bulunamadı"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
        <Button
          type="primary"
          onClick={() => navigate(all_routes.superAdminCompanies)}
          style={{ marginTop: 16 }}
        >
          Şirketlere Dön
        </Button>
      </div>
    );
  }

  const weekDays = [
    { label: 'Pazartesi', value: 'Monday' },
    { label: 'Salı', value: 'Tuesday' },
    { label: 'Çarşamba', value: 'Wednesday' },
    { label: 'Perşembe', value: 'Thursday' },
    { label: 'Cuma', value: 'Friday' },
    { label: 'Cumartesi', value: 'Saturday' },
    { label: 'Pazar', value: 'Sunday' },
  ];

  const showUserEditModal = (user: any) => {
    const fullUser = company?.users?.find(u => u.id === user.id);
    if (!fullUser) {
      message.error("Kullanıcı verileri bulunamadı.");
      return;
    }
    setEditingUser(fullUser);
    
    const { password, ...userData } = fullUser; // şifreyi form verisinden çıkar

    const departmentIds = userData.department?.map((d: any) => d.id) || [];
    const branchIds = userData.branch?.map((b: any) => b.id) || [];
    editForm.setFieldsValue({
      ...userData,
      birthDate: userData.birthDate ? moment(userData.birthDate) : null,
      departmentIds,
      branchIds,
      shiftType: userData.isFixedShift ? 'fixed' : 'assignment',
      primaryDepartmentId: userData.primaryDepartment?.id,
      password: '', // Şifre alanını boş başlat
    });
    setIsUserEditModalVisible(true);
  };

  const handleUpdateUser = async (values: any) => {
    if (!editingUser) return;
    
    const payload: any = {};

    const formValues = {
      ...values,
      isFixedShift: values.shiftType === 'fixed'
    };
    delete formValues.shiftType;

    // Sadece değişen alanları payload'a ekle
    Object.keys(formValues).forEach((key: string) => {
      const formValue = formValues[key];
      const userValue = editingUser[key];
      
      // Moment.js nesnelerini ISO string formatına çevir
      if (moment.isMoment(formValue)) {
        if (!formValue.isSame(userValue)) {
           payload[key] = formValue.toISOString();
        }
      } else if (JSON.stringify(formValue) !== JSON.stringify(userValue)) {
        payload[key] = formValue;
      }
    });

    if (values.password && values.password !== values.confirmPassword) {
      message.error("Şifreler uyuşmuyor!");
      return;
    }

    if (!values.password) {
      delete payload.password;
    }
    delete payload.confirmPassword;


    if (Object.keys(payload).length === 0) {
        message.info("Değişiklik yapılmadı.");
        setIsUserEditModalVisible(false);
        return;
    }

    try {
        await userService.updateUserBySuperAdmin(editingUser.id, payload);
        message.success("Kullanıcı başarıyla güncellendi.");
        setIsUserEditModalVisible(false);
        setEditingUser(null);
        fetchCompany(); // Verileri tazelemek için
    } catch (error) {
        handleApiError(error, t);
    }
  };

  const showBranchEditModal = (branch: Store) => {
    setEditingBranch(branch);
    editForm.setFieldsValue(branch);
    setIsBranchEditModalVisible(true);
  };

  const handleUpdateBranch = async (values: UpdateBranchDto) => {
    if (!editingBranch) return;
    try {
      await branchService.updateBranchBySuperAdmin(editingBranch.id, values);
      message.success("Şube başarıyla güncellendi.");
      setIsBranchEditModalVisible(false);
      fetchCompany();
    } catch (error) {
      handleApiError(error, t);
    }
  };

  const showDepartmentEditModal = (department: DepartmentDto) => {
    setEditingDepartment(department);
    const formValues = {
      ...department,
      fixedShiftStartTime: department.fixedShiftStartTime ? moment(department.fixedShiftStartTime, 'HH:mm') : null,
      fixedShiftEndTime: department.fixedShiftEndTime ? moment(department.fixedShiftEndTime, 'HH:mm') : null,
    };
    editForm.setFieldsValue(formValues);
    setIsDepartmentEditModalVisible(true);
  };

  const handleUpdateDepartment = async (values: UpdateDepartmentDto) => {
    if (!editingDepartment) return;
    try {
      const payload = {
        ...values,
        fixedShiftStartTime: values.fixedShiftStartTime ? moment(values.fixedShiftStartTime).format('HH:mm') : undefined,
        fixedShiftEndTime: values.fixedShiftEndTime ? moment(values.fixedShiftEndTime).format('HH:mm') : undefined,
      };
      await departmentService.updateDepartmentBySuperAdmin(editingDepartment.id, payload);
      message.success("Departman başarıyla güncellendi.");
      setIsDepartmentEditModalVisible(false);
      fetchCompany();
    } catch (error) {
      handleApiError(error, t);
    }
  };

  const showSubscriptionEditModal = () => {
    setIsSubscriptionModalVisible(true);
  };

  const handleUpdateSubscription = async () => {
    if (!id) return;
    try {
      const currentValues = await subscriptionEditForm.validateFields();
      const toSqlDateTime = (val: any, nullable: boolean = false) => {
        if (!val && nullable) return null;
        if (!val && !nullable) return undefined as unknown as string;
        const dateLike: Date = (val && typeof val === 'object')
          ? (val.toDate ? val.toDate() : (val.$d instanceof Date ? val.$d : new Date(val)))
          : new Date(val);
        return moment(dateLike).format('YYYY-MM-DD HH:mm:ss');
      };

      const payload: any = {
        userLimit: currentValues.userLimit,
        subscriptionStatus: currentValues.subscriptionStatus,
        activeSubscriptionExpiresAt: toSqlDateTime(currentValues.activeSubscriptionExpiresAt, false),
        gracePeriodEndsAt: toSqlDateTime(currentValues.gracePeriodEndsAt, true),
      };
      await companyService.updateSubscriptionBySuperAdmin(Number(id), payload);
      message.success("Abonelik bilgileri başarıyla güncellendi.");
      setIsSubscriptionModalVisible(false);
      // Re-fetch subscription data after update
      const data = await companyService.getCompanyDetailsForSuperAdmin(Number(id));
      setSubscriptionInfo(data);
    } catch (error: any) {
      if (error && error.errorFields) {
      } else {
        handleApiError(error, t);
      }
    }
  };

  // === PARASUT İŞLEMLERİ ===

  // Parasut fatura oluşturma
  const handleCreateInvoice = async (record: PaymentRecord) => {
    try {
      setParasutLoading({ ...parasutLoading, [`create_${record.id}`]: true });
      
      const payload = {
        companyId: Number(id),
        description: record.description || `${company?.name} - Abonelik Ödemesi`,
        amount: record.amountPaid || 0,
        currency: record.currency || 'TRY',
        contactName: company?.name || '',
        contactEmail: company?.email || '',
        contactPhone: company?.phone || '',
        taxNumber: company?.taxNumber || '',
        items: [{
          description: record.description || 'Abonelik Paketi',
          quantity: 1,
          unitPrice: record.amountPaid || 0,
          vatRate: 20
        }]
      };

      const result = await parasutService.createManualInvoice(payload);
      message.success('Parasut faturası başarıyla oluşturuldu');
      
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setParasutLoading({ ...parasutLoading, [`create_${record.id}`]: false });
    }
  };

  // Parasut fatura resmileştirme
  const handleOfficializeInvoice = async (record: PaymentRecord) => {
    if (!record.parasutInvoiceId) {
      message.warning('Bu kayıt için Parasut fatura ID\'si bulunamadı');
      return;
    }

    Modal.confirm({
      title: 'Faturayı resmileştirmek istediğinize emin misiniz?',
      icon: <ExclamationCircleOutlined />,
      content: 'Bu işlem geri alınamaz ve fatura e-Fatura/e-Arşiv olarak resmileştirilecek.',
      okText: 'Evet, Resmileştir',
      cancelText: 'İptal',
      onOk: async () => {
        try {
          setParasutLoading({ ...parasutLoading, [`officialize_${record.id}`]: true });
          
          const result = await parasutService.officializeInvoice(record.parasutInvoiceId!);
          
          if (result.operationId) {
            message.loading({
              content: 'Resmileştirme işlemi başlatıldı, durum takip ediliyor...',
              key: `officialize_${record.id}`,
              duration: 0,
            });
            
            // İşlem durumunu takip et
            const finalStatus = await parasutService.pollOperationStatus(result.operationId);
            
            if (finalStatus.status === 'completed') {
              message.success({
                content: 'Fatura başarıyla resmileştirildi',
                key: `officialize_${record.id}`,
              });
            } else {
              message.error({
                content: `Resmileştirme başarısız: ${finalStatus.error || 'Bilinmeyen hata'}`,
                key: `officialize_${record.id}`,
              });
            }
          } else {
            message.success('Fatura resmileştirme işlemi başlatıldı');
          }
          
        } catch (error: any) {
          message.error({
            content: 'Resmileştirme hatası',
            key: `officialize_${record.id}`,
          });
          handleApiError(error, t);
        } finally {
          setParasutLoading({ ...parasutLoading, [`officialize_${record.id}`]: false });
        }
      },
    });
  };

  // Parasut PDF indirme
  const handleDownloadInvoicePdf = async (record: PaymentRecord) => {
    if (!record.parasutInvoiceId) {
      message.warning('Bu kayıt için Parasut fatura ID\'si bulunamadı');
      return;
    }

    try {
      setParasutLoading({ ...parasutLoading, [`download_${record.id}`]: true });
      
      // Önce fatura detayını al
      const invoiceDetail = await parasutService.getSalesInvoice(record.parasutInvoiceId);
      
      // E-Fatura veya E-Arşiv ID'sini kontrol et
      if (invoiceDetail.eInvoiceId) {
        const filename = `e-fatura-${record.parasutInvoiceId}.pdf`;
        await parasutService.downloadPdf(`/parasut/e-invoices/${invoiceDetail.eInvoiceId}/pdf`, filename);
        message.success('E-Fatura PDF\'i indirildi');
      } else if (invoiceDetail.eArchiveId) {
        const filename = `e-arsiv-${record.parasutInvoiceId}.pdf`;
        await parasutService.downloadPdf(`/parasut/e-archives/${invoiceDetail.eArchiveId}/pdf`, filename);
        message.success('E-Arşiv PDF\'i indirildi');
      } else {
        message.warning('Bu fatura henüz resmileştirilmemiş, PDF mevcut değil');
      }
    } catch (error: any) {
      handleApiError(error, t);
    } finally {
      setParasutLoading({ ...parasutLoading, [`download_${record.id}`]: false });
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Şirket Detayları</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.superAdminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.superAdminCompanies}>Şirketler</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {company?.name}
                  </li>
                </ol>
              </nav>
            </div>
            {user?.permissions?.includes(PermissionType.SUPER_ADMIN_DELETE_COMPANY) && (
            <div className="ms-2">
              <Link
                to={all_routes.superAdminCompanies}
                className="btn btn-outline-primary me-2"
              >
                <ArrowLeftOutlined /> Geri
              </Link>
              
              <Button
                type="primary"
                danger
                size="large"
                className="btn btn-danger me-2"
                onClick={handleDelete}
              >
                <DeleteOutlined />
                Sil
              </Button>
            </div>
            )}
          </div>
          {/* /Breadcrumb */}

          {/* Şirket Bilgileri Kartı */}
          <Card className="company-details-card mb-4">
            <div className="details-header">
              <div className="d-flex">
                <div className="company-logo d-flex align-items-center justify-content-center bg-light">
                  <BuildOutlined style={{ fontSize: 36 }} />
                </div>
                <div className="company-info">
                  <h2 className="company-name">
                    {company?.name} <span>{getStatusBadge(company?.status)}</span>
                  </h2>
                  <div className="company-meta">
                    <span>
                      <BankOutlined className="me-1" /> Vergi No: {company?.taxNumber}
                    </span>
                    <span className="ms-3">
                      <BankOutlined className="me-1" /> Vergi Dairesi: {company?.taxOffice}
                    </span>
                  </div>
                  <div className="company-meta">
                    <span>
                      <CalendarOutlined className="me-1" /> Kayıt Tarihi:{" "}
                      {moment(company?.createdAt).format("DD.MM.YYYY")}
                    </span>
                    {company?.createdBySuperAdmin && (
                      <span className="ms-3">
                        <CrownOutlined className="me-1" style={{ color: '#faad14' }} /> 
                        Oluşturan: <Tag color="gold" icon={<CrownOutlined />} style={{ marginLeft: '4px' }}>
                          {company?.createdBySuperAdminName || 'Süper Admin'}
                        </Tag>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <Row gutter={[16, 16]}>
              <Col xs={24} lg={8}>
                <Card className="company-stats-card">
                  <Statistic
                    title="Çalışan Sayısı"
                    value={company?.users?.length || 0}
                    prefix={<TeamOutlined className="stats-icon bg-primary-light text-primary" />}
                  />
                </Card>
              </Col>
              <Col xs={24} lg={8}>
                <Card className="company-stats-card">
                  <Statistic
                    title="Şube Sayısı"
                    value={company?.branches?.length || 0}
                    prefix={<HomeOutlined className="stats-icon bg-success-light text-success" />}
                  />
                </Card>
              </Col>
              <Col xs={24} lg={8}>
                <Card className="company-stats-card">
                  <Statistic
                    title="Departman Sayısı"
                    value={company?.departments?.length || 0}
                    prefix={<ApartmentOutlined className="stats-icon bg-warning-light text-warning" />}
                  />
                </Card>
              </Col>
            </Row>
          </Card>

          {/* Abonelik Bilgileri Kartı */}
          <Card 
            className="company-details-card mb-4" 
            title={
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center"><CrownOutlined className="me-2" />Abonelik ve Limit Bilgileri</div>
                {user?.permissions?.includes(PermissionType.SUPER_ADMIN_VIEW_FINANCIALS) && (
                  <div>
                    <Button icon={<EditOutlined />} onClick={showSubscriptionEditModal} className="me-2">Düzenle</Button>
                    <Button icon={<HistoryOutlined />} onClick={showPaymentHistory}>Satın Alım Geçmişi</Button>
                  </div>
                )}
              </div>
            }
          >
            {subLoading ? (
              <div className="text-center p-4"><Spin /></div>
            ) : subscriptionInfo ? (
              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} lg={6}>
                  <Card bordered={false} style={{ backgroundColor: '#fafafa', height: '100%', textAlign: 'center' }}>
                    <Typography.Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>Abonelik Durumu</Typography.Text>
                    <Tag color={getSubscriptionStatusColor(subscriptionInfo.subscriptionStatus)} style={{ fontSize: '14px', padding: '6px 12px' }}>
                      {translateSubscriptionStatus(subscriptionInfo.subscriptionStatus)}
                    </Tag>
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card bordered={false} style={{ backgroundColor: '#fafafa', height: '100%', textAlign: 'center' }}>
                    <Typography.Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>Kullanıcı Limiti</Typography.Text>
                    {subscriptionInfo.userLimit > 0 ? (
                      <Progress 
                        type="circle" 
                        percent={Math.round((subscriptionInfo.currentUserCount / subscriptionInfo.userLimit) * 100)} 
                        width={80}
                        format={() => <div style={{fontSize: '12px'}}>{subscriptionInfo.currentUserCount} / {subscriptionInfo.userLimit}</div>}
                      />
                    ) : (
                      <Typography.Title level={4}>Limitsiz</Typography.Title>
                    )}
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card bordered={false} style={{ backgroundColor: '#fafafa', height: '100%', textAlign: 'center' }}>
                    <Typography.Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>
                      {subscriptionInfo.subscriptionStatus === SubscriptionStatusEnum.IN_GRACE_PERIOD
                        ? "Tolerans Süresi Bitişi"
                        : "Abonelik Bitişi"}
                    </Typography.Text>
                    <Typography.Title level={4}>
                      <CalendarOutlined className="me-2" />
                      {subscriptionInfo.subscriptionStatus === SubscriptionStatusEnum.IN_GRACE_PERIOD
                        ? (subscriptionInfo.gracePeriodEndsAt
                            ? moment(subscriptionInfo.gracePeriodEndsAt).format("DD.MM.YYYY")
                            : 'N/A')
                        : (subscriptionInfo.activeSubscriptionExpiresAt
                            ? moment(subscriptionInfo.activeSubscriptionExpiresAt).format("DD.MM.YYYY")
                            : 'N/A')
                      }
                    </Typography.Title>
                  </Card>
                </Col>
                <Col xs={24} sm={12} lg={6}>
                  <Card bordered={false} style={{ backgroundColor: '#fafafa', height: '100%', textAlign: 'center' }}>
                    <Typography.Text type="secondary" style={{ marginBottom: '12px', display: 'block' }}>Son Paket</Typography.Text>
                    <Typography.Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'daha fazla' }} style={{ minHeight: '44px' }}>
                      {subscriptionInfo.subscriptionDetails.lastPackageDescription}
                    </Typography.Paragraph>
                  </Card>
                </Col>
              </Row>
            ) : (
              <Empty description="Abonelik ve limit bilgileri alınamadı." />
            )}
          </Card>
          {/* Ödeme Geçmişi Modal */}
          <Modal
            title="Satın Alım Geçmişi"
            visible={isHistoryModalVisible}
            onCancel={() => setIsHistoryModalVisible(false)}
            footer={null}
            width={1000}
            bodyStyle={{ paddingTop: '20px' }}
          >
            <Table
              dataSource={paymentHistory}
              loading={historyLoading}
              rowKey="id"
              columns={[
                {
                  title: 'Ödeme Tarihi',
                  dataIndex: 'paidAt',
                  key: 'paidAt',
                  render: (text) => text ? moment(text).format('DD.MM.YYYY HH:mm') : '-',
                },
                {
                  title: 'Açıklama',
                  dataIndex: 'description',
                  key: 'description',
                },
                {
                  title: 'Tutar',
                  dataIndex: 'amountPaid',
                  key: 'amountPaid',
                  render: (amount: number, record: PaymentRecord) => `${amount ? amount.toFixed(2) : '0.00'} ${record.currency || 'TRY'}`,
                },
                {
                  title: 'Durum',
                  dataIndex: 'paymentStatus',
                  key: 'paymentStatus',
                  render: (status: string) => <Tag color={getPaymentStatusColor(status)}>{translatePaymentStatus(status)}</Tag>,
                },
                {
                  title: 'Paket Başlangıç',
                  dataIndex: 'startDate',
                  key: 'startDate',
                  render: (text) => moment(text).format('DD.MM.YYYY'),
                },
                {
                  title: 'Paket Bitiş',
                  dataIndex: 'expiryDate',
                  key: 'expiryDate',
                  render: (text) => moment(text).format('DD.MM.YYYY'),
                },
                {
                  title: 'Parasut İşlemleri',
                  key: 'parasutActions',
                  width: 200,
                  render: (_, record: PaymentRecord) => (
                    <Space size="small">
                      {!record.parasutInvoiceId ? (
                        <Button
                          size="small"
                          type="primary"
                          icon={<PlusOutlined />}
                          loading={parasutLoading[`create_${record.id}`]}
                          onClick={() => handleCreateInvoice(record)}
                          title="Parasut Faturası Oluştur"
                        >
                          Fatura Oluştur
                        </Button>
                      ) : (
                        <>
                          <Button
                            size="small"
                            icon={<FileProtectOutlined />}
                            loading={parasutLoading[`officialize_${record.id}`]}
                            onClick={() => handleOfficializeInvoice(record)}
                            title="Faturayı Resmileştir"
                          />
                          <Button
                            size="small"
                            icon={<DownloadOutlined />}
                            loading={parasutLoading[`download_${record.id}`]}
                            onClick={() => handleDownloadInvoicePdf(record)}
                            title="PDF İndir"
                          />
                        </>
                      )}
                    </Space>
                  ),
                },
              ]}
              pagination={{ pageSize: 5 }}
              scroll={{ x: 1200 }}
            />
          </Modal>

          {/* Modern Navigation */}
          <Card className="company-details-card mb-4">
            <div className="modern-nav-container">
              <div className="modern-nav">
                {navigationItems.map((item) => (
                  <button
                    key={item.key}
                    className={`modern-nav-item ${activeTab === item.key ? 'active' : ''}`}
                    onClick={() => setActiveTab(item.key)}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                    {item.count !== null && (
                      <span className="nav-count">{item.count}</span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="modern-tab-content">
              {renderTabContent()}
            </div>
          </Card>
        </div>

        {/* <FooterSection /> */}

        {/* Admin Kullanıcı Ekleme Modal */}
        <Modal
          title="Yeni Admin Kullanıcısı Ekle"
          open={isAddAdminModalVisible}
          onCancel={() => {
            setIsAddAdminModalVisible(false);
            form.resetFields();
          }}
          footer={null}
          width={700}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleAddAdmin}
            initialValues={{
              role: RolesEnum.ADMIN,
            }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Ad"
                  name="firstName"
                  rules={[{ required: true, message: "Ad alanı zorunludur" }]}
                >
                  <Input placeholder="Adını girin" size="large" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Soyad"
                  name="lastName"
                  rules={[{ required: true, message: "Soyad alanı zorunludur" }]}
                >
                  <Input placeholder="Soyadını girin" size="large" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="E-posta"
              name="email"
              rules={[
                { required: true, message: "E-posta alanı zorunludur" },
                { type: "email", message: "Geçerli bir e-posta adresi girin" }
              ]}
            >
              <Input placeholder="E-posta adresini girin" size="large" />
            </Form.Item>

            <Form.Item
              label="Şifre"
              name="password"
              rules={[
                { required: true, message: "Şifre alanı zorunludur" },
                { min: 6, message: "Şifre en az 6 karakter olmalıdır" }
              ]}
            >
              <Input.Password placeholder="Şifre girin" size="large" />
            </Form.Item>

            <Form.Item
              label="TC Kimlik No"
              name="nationalId"
              rules={[
                { required: true, whitespace: true, message: "TC Kimlik No alanı zorunludur" }
              ]}
            >
              <Input placeholder="TC Kimlik No / Yabancı Kimlik No" size="large" maxLength={11} />
            </Form.Item>

            <Form.Item
              label="Telefon"
              name="phone"
            >
              <Input placeholder="Telefon numarası" size="large" />
            </Form.Item>

            {/* Hidden fields */}
            <Form.Item name="role" hidden>
              <Input />
            </Form.Item>

            <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button onClick={() => {
                  setIsAddAdminModalVisible(false);
                  form.resetFields();
                }}>
                  İptal
                </Button>
                <Button type="primary" htmlType="submit" loading={addingAdmin}>
                  Admin Ekle
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>

        {/* Admin Kullanıcı Detay Modal */}
        <Modal
          title={null}
          visible={adminDetailModalVisible}
          onCancel={() => setAdminDetailModalVisible(false)}
          width={1000}
          footer={null}
          className="modern-detail-modal"
        >
          {selectedAdmin && (
            <div className="modal-content-wrapper">
              {/* Modal Header */}
              <div className="modal-header">
                <div className="modal-header-info">
                  <Avatar
                    size={60}
                    src={selectedAdmin.profilePicture ? `/uploads/${selectedAdmin.profilePicture}` : null}
                    icon={!selectedAdmin.profilePicture ? <UserOutlined /> : null}
                    className="modal-avatar"
                  />
                  <div className="modal-header-text">
                    <h3 className="modal-title" style={{ color: '#000' }}>{selectedAdmin.firstName} {selectedAdmin.lastName}</h3>
                    <p className="modal-subtitle">{selectedAdmin.title || 'Admin Kullanıcı'}</p>
                    <div className="modal-tags">
                      <Tag color="red">Admin</Tag>
                      <Tag color={selectedAdmin.status === 'active' ? 'success' : 'default'}>
                        {selectedAdmin.status === 'active' ? 'Aktif' : 'Pasif'}
                      </Tag>
                    </div>
                  </div>
                </div>
                {/* <Button
                  type="text"
                  icon={<i className="ti ti-x" />}
                  onClick={() => setAdminDetailModalVisible(false)}
                  className="modal-close-btn"
                /> */}
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="detail-grid">
                  {/* Kişisel Bilgiler - Sol taraf */}
                  <div className="detail-section detail-section-left">
                    <div className="detail-section-header">
                      <h4 className="detail-section-title">
                        <UserOutlined className="me-2" />
                        Kişisel Bilgiler
                      </h4>
                    </div>
                    <div className="detail-section-content">
                      <div className="detail-row">
                        <span className="detail-label">E-posta:</span>
                        <span className="detail-value">{selectedAdmin.email}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Telefon:</span>
                        <span className="detail-value">{selectedAdmin.phone || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Acil Durum İletişim:</span>
                        <span className="detail-value">{selectedAdmin.emergencyContact || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Doğum Tarihi:</span>
                        <span className="detail-value">
                          {selectedAdmin.birthDate ? moment(selectedAdmin.birthDate).format('DD.MM.YYYY') : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Medeni Durumu:</span>
                        <span className="detail-value">
                          {selectedAdmin.maritalStatus === 'married' ? 'Evli' :
                            selectedAdmin.maritalStatus === 'single' ? 'Bekar' : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Cinsiyet:</span>
                        <span className="detail-value">
                          {selectedAdmin.gender === 'male' ? 'Erkek' :
                            selectedAdmin.gender === 'female' ? 'Kadın' : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">TC Kimlik No:</span>
                        <span className="detail-value">{selectedAdmin.nationalId || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Eğitim Durumu:</span>
                        <span className="detail-value">
                          {selectedAdmin.educationLevel === 'bachelor' ? 'Lisans' :
                            selectedAdmin.educationLevel === 'master' ? 'Yüksek Lisans' :
                              selectedAdmin.educationLevel === 'doctorate' ? 'Doktora' :
                                selectedAdmin.educationLevel === 'highschool' ? 'Lise' : '-'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Adres ve İş Bilgileri - Sağ taraf */}
                  <div className="detail-section-right">
                    {/* Adres Bilgileri */}
                    <div className="detail-section detail-section-compact">
                      <div className="detail-section-header">
                        <h4 className="detail-section-title">
                          <HomeOutlined className="me-2" />
                          Adres Bilgileri
                        </h4>
                      </div>
                      <div className="detail-section-content">
                        <div className="detail-row">
                          <span className="detail-label">Adres:</span>
                          <span className="detail-value">{selectedAdmin.address || '-'}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Şehir:</span>
                          <span className="detail-value">{selectedAdmin.city || '-'}</span>
                        </div>
                      </div>
                    </div>

                    {/* İş Bilgileri */}
                    <div className="detail-section detail-section-compact">
                      <div className="detail-section-header">
                        <h4 className="detail-section-title">
                          <BankOutlined className="me-2" />
                          İş Bilgileri
                        </h4>
                      </div>
                      <div className="detail-section-content">
                        <div className="detail-row">
                          <span className="detail-label">İşe Başlama Tarihi:</span>
                          <span className="detail-value">
                            {selectedAdmin.hireDate ? moment(selectedAdmin.hireDate).format('DD.MM.YYYY') : '-'}
                          </span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Çalışma Süresi:</span>
                          <span className="detail-value">
                            {selectedAdmin.workDuration ? `${selectedAdmin.workDuration} saat` : '0 saat'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Yetkiler */}
                  <div className="detail-section detail-section-full">
                    <div className="detail-section-header">
                      <h4 className="detail-section-title">
                        <i className="ti ti-shield-check me-2" />
                        Yetkiler ve İzinler
                      </h4>
                    </div>
                    <div className="detail-section-content">
                      <div className="permissions-grid">
                        {selectedAdmin.permissions && selectedAdmin.permissions.length > 0 ? (
                          selectedAdmin.permissions.map((permission: string) => (
                            <div key={permission} className="permission-item">
                              <i className="ti ti-check-circle permission-icon" />
                              <span className="permission-text">{getPermissionName(permission)}</span>
                            </div>
                          ))
                        ) : (
                          <div className="no-permissions">
                            <i className="ti ti-info-circle me-2" />
                            <span>Özel izin tanımlanmamış</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <Button
                  type="default"
                  onClick={() => setAdminDetailModalVisible(false)}
                  className="modal-close-footer-btn"
                >
                  Kapat
                </Button>
              </div>
            </div>
          )}
        </Modal>

        {/* Kullanıcı Detay Modal */}
        <Modal
          title={null}
          visible={userDetailModalVisible}
          onCancel={() => setUserDetailModalVisible(false)}
          width={1000}
          footer={null}
          className="modern-detail-modal"
        >
          {selectedUser && (
            <div className="modal-content-wrapper">
              {/* Modal Header */}
              <div className="modal-header">
                <div className="modal-header-info">
                  <Avatar
                    size={60}
                    src={selectedUser.profilePicture ? `/uploads/${selectedUser.profilePicture}` : null}
                    icon={!selectedUser.profilePicture ? <UserOutlined /> : null}
                    className="modal-avatar"
                  />
                  <div className="modal-header-text">
                    <h3 className="modal-title">{selectedUser.firstName} {selectedUser.lastName}</h3>
                    <p className="modal-subtitle">{selectedUser.title || 'Çalışan'}</p>
                    <div className="modal-tags">
                      <Tag color={selectedUser.role?.toLowerCase() === 'admin' ? 'red' :
                        selectedUser.role?.toLowerCase() === 'manager' ? 'orange' :
                          selectedUser.role?.toLowerCase() === 'supervisor' ? 'blue' : 'green'}>
                        {selectedUser.role?.toLowerCase() === 'admin' ? 'Admin' :
                          selectedUser.role?.toLowerCase() === 'manager' ? 'Yönetici' :
                            selectedUser.role?.toLowerCase() === 'supervisor' ? 'Sorumlu' : 'Çalışan'}
                      </Tag>
                      <Tag color={selectedUser.status === 'active' ? 'success' : 'default'}>
                        {selectedUser.status === 'active' ? 'Aktif' : 'Pasif'}
                      </Tag>
                    </div>
                  </div>
                </div>
                {/* <Button
                  type="text"
                  icon={<i className="ti ti-x" />}
                  onClick={() => setUserDetailModalVisible(false)}
                  className="modal-close-btn"
                /> */}
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                <div className="detail-grid">
                  {/* Kişisel Bilgiler - Sol taraf */}
                  <div className="detail-section detail-section-left">
                    <div className="detail-section-header">
                      <h4 className="detail-section-title">
                        <UserOutlined className="me-2" />
                        Kişisel Bilgiler
                      </h4>
                    </div>
                    <div className="detail-section-content">
                      <div className="detail-row">
                        <span className="detail-label">E-posta:</span>
                        <span className="detail-value">{selectedUser.email}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Telefon:</span>
                        <span className="detail-value">{selectedUser.phone || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Acil Durum İletişim:</span>
                        <span className="detail-value">{selectedUser.emergencyContact || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Doğum Tarihi:</span>
                        <span className="detail-value">
                          {selectedUser.birthDate ? moment(selectedUser.birthDate).format('DD.MM.YYYY') : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Medeni Durumu:</span>
                        <span className="detail-value">
                          {selectedUser.maritalStatus === 'married' ? 'Evli' :
                            selectedUser.maritalStatus === 'single' ? 'Bekar' : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Cinsiyet:</span>
                        <span className="detail-value">
                          {selectedUser.gender === 'male' ? 'Erkek' :
                            selectedUser.gender === 'female' ? 'Kadın' : '-'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">TC Kimlik No:</span>
                        <span className="detail-value">{selectedUser.nationalId || '-'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Eğitim Durumu:</span>
                        <span className="detail-value">
                          {selectedUser.educationLevel === 'bachelor' ? 'Lisans' :
                            selectedUser.educationLevel === 'master' ? 'Yüksek Lisans' :
                              selectedUser.educationLevel === 'doctorate' ? 'Doktora' :
                                selectedUser.educationLevel === 'highschool' ? 'Lise' : '-'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Adres ve İş Bilgileri - Sağ taraf */}
                  <div className="detail-section-right">
                    {/* Adres Bilgileri */}
                    <div className="detail-section detail-section-compact">
                      <div className="detail-section-header">
                        <h4 className="detail-section-title">
                          <HomeOutlined className="me-2" />
                          Adres Bilgileri
                        </h4>
                      </div>
                      <div className="detail-section-content">
                        <div className="detail-row">
                          <span className="detail-label">Adres:</span>
                          <span className="detail-value">{selectedUser.address || '-'}</span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Şehir:</span>
                          <span className="detail-value">{selectedUser.city || '-'}</span>
                        </div>
                      </div>
                    </div>

                    {/* İş Bilgileri */}
                    <div className="detail-section detail-section-compact">
                      <div className="detail-section-header">
                        <h4 className="detail-section-title">
                          <BankOutlined className="me-2" />
                          İş Bilgileri
                        </h4>
                      </div>
                      <div className="detail-section-content">
                        <div className="detail-row">
                          <span className="detail-label">İşe Başlama Tarihi:</span>
                          <span className="detail-value">
                            {selectedUser.hireDate ? moment(selectedUser.hireDate).format('DD.MM.YYYY') : '-'}
                          </span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Çalışma Süresi:</span>
                          <span className="detail-value">
                            {selectedUser.workDuration ? `${selectedUser.workDuration} saat` : '0 saat'}
                          </span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Yıllık İzin Limiti:</span>
                          <span className="detail-value">
                            {selectedUser.annualLeaveLimit ? `${selectedUser.annualLeaveLimit} gün` : '-'}
                          </span>
                        </div>
                        <div className="detail-row">
                          <span className="detail-label">Kalan Yıllık İzin:</span>
                          <span className="detail-value">
                            {selectedUser.remainingAnnualLeaveLimit ? `${selectedUser.remainingAnnualLeaveLimit} gün` : '-'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Yetkiler (Eğer varsa) */}
                  {selectedUser.permissions && selectedUser.permissions.length > 0 && (
                    <div className="detail-section detail-section-full">
                      <div className="detail-section-header">
                        <h4 className="detail-section-title">
                          <i className="ti ti-shield-check me-2" />
                          Yetkiler ve İzinler
                        </h4>
                      </div>
                      <div className="detail-section-content">
                        <div className="permissions-grid">
                          {selectedUser.permissions.map((permission: string) => (
                            <div key={permission} className="permission-item">
                              <i className="ti ti-check-circle permission-icon" />
                              <span className="permission-text">{getPermissionName(permission)}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer">
                <Button
                  type="default"
                  onClick={() => setUserDetailModalVisible(false)}
                  className="modal-close-footer-btn"
                >
                  Kapat
                </Button>
              </div>
            </div>
          )}
        </Modal>
      </div>
      {/* /Page Wrapper */}

      {/* Genel bilgiler düzenleme kaldırıldı */}
          {/* <Form form={editForm} layout="vertical" onFinish={handleUpdateCompany} initialValues={company || {}}>
            <Tabs defaultActiveKey="1"> */}
              <TabPane tab="Temel & Vergi Bilgileri" key="1">
                <Card title="Temel Bilgiler" bordered={false}>
                  <Row gutter={16}>
                    <Col span={12}><Form.Item name="name" label="Şirket Adı"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="email" label="E-posta"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="phone" label="Telefon"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="address" label="Adres"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="city" label="Şehir"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="zipCode" label="Posta Kodu"><Input /></Form.Item></Col>
                  </Row>
                </Card>
                <Card title="Vergi Bilgileri" bordered={false} className="mt-4">
                  <Row gutter={16}>
                    <Col span={12}><Form.Item name="taxNumber" label="Vergi No"><Input /></Form.Item></Col>
                    <Col span={12}><Form.Item name="taxOffice" label="Vergi Dairesi"><Input /></Form.Item></Col>
                  </Row>
                </Card>
              </TabPane>
              <TabPane tab="Genel Ayarlar" key="2">
                <Row gutter={16}>
                    <Col span={8}><Form.Item name={["settings", "annualLeaveLimit"]} label="Yıllık İzin Limiti (Gün)"><InputNumber style={{width: '100%'}} /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "defaultBreakDuration"]} label="Varsayılan Mola Süresi (dk)"><InputNumber style={{width: '100%'}} /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "maxBreakDuration"]} label="Maksimum Mola Süresi (dk)"><InputNumber style={{width: '100%'}} /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "maxDailyWorkHours"]} label="Maks. Günlük Çalışma Saati"><InputNumber style={{width: '100%'}} /></Form.Item></Col>
                </Row>
                <Divider />
                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item name={["settings", "lateTolerance"]} label="Geç Kalma Toleransı" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.settings?.lateTolerance !== currentValues.settings?.lateTolerance
                      }
                    >
                      {({ getFieldValue }) =>
                        getFieldValue(['settings', 'lateTolerance']) ? (
                          <Form.Item
                            name={["settings", "lateTolerationMinutes"]}
                            label="Tolerans Süresi (dk)"
                            rules={[{ required: true, message: 'Lütfen süre girin!' }]}
                          >
                            <InputNumber min={0} style={{ width: '100%' }} />
                          </Form.Item>
                        ) : null
                      }
                    </Form.Item>
                  </Col>
                   <Col span={8}>
                    <Form.Item name={["settings", "ipControl"]} label="IP Kontrolü" valuePropName="checked">
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Vardiya Ayarları" key="3">
                 <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name={["settings", "shiftMode"]} label="Vardiya Modu">
                            <Select><Option value="assignment">Atama Bazlı</Option><Option value="fixed">Sabit</Option><Option value="both">Her ikisi</Option></Select>
                        </Form.Item>
                    </Col>
                 </Row>
                <Form.Item name={["settings", "fixedShiftDays"]} label="Sabit Vardiya Günleri"><Checkbox.Group options={weekDays} /></Form.Item>
              </TabPane>
              <TabPane tab="Bildirim Ayarları" key="4">
                <Row gutter={16}>
                    <Col span={8}><Form.Item name={["settings", "sendMailLeave"]} label="İzin E-postası" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendMailTicket"]} label="Talep E-postası" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendMailExcuse"]} label="Mazeret E-postası" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendNotifLeave"]} label="İzin Bildirimi" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendNotifTicket"]} label="Talep Bildirimi" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendNotifExcuse"]} label="Mazeret Bildirimi" valuePropName="checked"><Switch /></Form.Item></Col>
                    <Col span={8}><Form.Item name={["settings", "sendNotifBreak"]} label="Mola Bildirimi" valuePropName="checked"><Switch /></Form.Item></Col>
                </Row>
              </TabPane>
            {/* </Tabs>
          </Form> */}

        {/* Kullanıcı düzenleme kaldırıldı */}

        {/* Şube düzenleme kaldırıldı */}

        {/* Departman düzenleme kaldırıldı */}

        <Modal
          title="Abonelik Bilgilerini Düzenle"
          visible={isSubscriptionModalVisible}
          onCancel={() => setIsSubscriptionModalVisible(false)}
          footer={null}
          destroyOnClose
        >
          {subscriptionInfo && (
            <Form
              form={subscriptionEditForm}
              layout="vertical"
              onFinish={handleUpdateSubscription}
              initialValues={{
                userLimit: subscriptionInfo.userLimit,
                subscriptionStatus: subscriptionInfo.subscriptionStatus,
                activeSubscriptionExpiresAt: subscriptionInfo.activeSubscriptionExpiresAt ? moment(subscriptionInfo.activeSubscriptionExpiresAt) : null,
                gracePeriodEndsAt: subscriptionInfo.gracePeriodEndsAt ? moment(subscriptionInfo.gracePeriodEndsAt) : null,
              }}
            >
              <Form.Item name="userLimit" label="Kullanıcı Limiti" rules={[{ required: true }]}>
                <InputNumber style={{width: "100%"}} />
              </Form.Item>
              <Form.Item name="subscriptionStatus" label="Abonelik Durumu" rules={[{ required: true }]}>
                <Select>
                  <Option value={SubscriptionStatusEnum.ACTIVE}>Aktif</Option>
                  <Option value={SubscriptionStatusEnum.INACTIVE}>Pasif</Option>
                  <Option value={SubscriptionStatusEnum.IN_GRACE_PERIOD}>Tolerans Süresinde</Option>
                  <Option value={SubscriptionStatusEnum.EXPIRED}>Süresi Dolmuş</Option>
                  <Option value={SubscriptionStatusEnum.TRIAL}>Deneme</Option>
                </Select>
              </Form.Item>
              <Form.Item name="activeSubscriptionExpiresAt" label="Abonelik Bitiş Tarihi">
                <DatePicker picker="date" style={{width: "100%"}} placeholder="Tarih Seç" />
              </Form.Item>
              {statusValue === SubscriptionStatusEnum.IN_GRACE_PERIOD && (
                <Form.Item name="gracePeriodEndsAt" label="Tolerans Bitiş Tarihi" rules={[{ required: true, message: 'Lütfen tolerans bitiş tarihini girin!' }]}>
                  <DatePicker picker="date" style={{width: "100%"}} placeholder="Tarih Seç" />
                </Form.Item>
              )}
               <div style={{ textAlign: 'right', marginTop: 24 }}>
                  <Button onClick={() => setIsSubscriptionModalVisible(false)} style={{ marginRight: 8 }}>
                    İptal
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Kaydet
                  </Button>
                </div>
            </Form>
          )}
        </Modal>
    </>
  );
};

export default CompanyDetails;
